module.exports = __webpack_public_path__ + "img/logo.0acf53f5.svg";